import React from 'react';
import { HiDocumentText, HiX } from 'react-icons/hi';

const isImage = (att) => (att?.fileType || '').startsWith('image/');

/**
 * Renders a single message/activity attachment — an image thumbnail or a file
 * chip. Works for a pending (local `previewUrl`) or uploaded (`url`) item.
 */
const AttachmentView = ({ attachment, onRemove, uploading, progress }) => {
  const src = attachment?.previewUrl || attachment?.url;
  const image = isImage(attachment);

  return (
    <div className="relative inline-block">
      {image && src ? (
        <a
          href={attachment?.url || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
          onClick={(e) => uploading && e.preventDefault()}
        >
          <img
            src={src}
            alt={attachment?.fileName || 'attachment'}
            className="w-32 h-32 object-cover rounded-xl border border-surface-200"
          />
        </a>
      ) : (
        <a
          href={attachment?.url || undefined}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 px-3 py-2 max-w-[200px] rounded-xl border border-surface-200 bg-surface-50 hover:bg-surface-100 transition-colors"
          onClick={(e) => (uploading || !attachment?.url) && e.preventDefault()}
        >
          <HiDocumentText className="text-ink-400 flex-shrink-0" />
          <span className="text-xs text-ink-700 truncate">{attachment?.fileName || 'Attachment'}</span>
        </a>
      )}

      {uploading && (
        <div className="absolute inset-0 flex items-center justify-center rounded-xl bg-ink-800/45 text-white text-xs font-bold">
          {progress != null ? `${progress}%` : '…'}
        </div>
      )}

      {onRemove && !uploading && (
        <button
          type="button"
          onClick={onRemove}
          className="absolute -top-2 -right-2 bg-white rounded-full shadow p-0.5 text-ink-600 hover:text-ink-900"
          aria-label="Remove attachment"
        >
          <HiX className="text-sm" />
        </button>
      )}
    </div>
  );
};

export default AttachmentView;
